(function($, Drupal) {
  Drupal.behaviors.find_a_course = {
    attach: function(context, settings) {
      $('.course-filters-trigger').once('toggle-filters').on('click touch', function() {
        $(this).toggleClass('open');

        if ($(this).hasClass('open')) {
          $(this).next('.views-exposed-form').slideDown(300);
        }
        else {
          $(this).next('.views-exposed-form').slideUp(300);
        }
      });

      if ($('.pager__item--last').length) {
        let $href = $('.pager__item--last').find('a').attr('href');
        if (!$('a[href*="' + $href + '"]').first().parent().hasClass('pager__item--last')) {
          $('a[href*="' + $href + '"]').first().parent().once('remove-duplicate').remove();
        }
      }
      if ($('.form-item-format').length !== 0) {
        // $('.form-item-format select').chosen();
        // $('form[id=views-exposed-form-course-instance-course-instance] .form-item-sort-order label').text('Sort by Date');
      }
    }
  };
})(jQuery, Drupal);
